var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import EdButton, { EdButtonIcon, } from "@frameworks/web/components/generic/edbutton/edButton";
import React, { useMemo, useRef, useState } from "react";
import { fundFilters } from "@frameworks/web/components/features/Markets/MutualFunds/constants";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { EMFFilterType, } from "@domains/features/Markets/MutualFunds/entities/MutualFundsSchemesEntity";
import di from "@mainDi/features/mutualFund/servicelocator";
import _ from "underscore";
import debounce from "@frameworks/web/utils/debounce";
import { useParams } from "react-router-dom";
import { MFSchemesPlanTypes, MFSchemsPlanes, } from "@domains/features/Markets/MutualFunds/entities/MFCommon";
import { useCustomSelector } from "@frameworks/shared-library/components/customHooks/customUseSector";
import FilterValues from "./FilterValues";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsSearchFilterSection.scss";
import GenericTabs from "@frameworks/shared-library/components/GenericTabs";
import OfferingsFilterTab from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsFilterTab/OfferingsFilterTab";
import OfferingsSortTab from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsSortTab/OfferingsSortTab";
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import { defaultMutualFundFilterConfig, FilterSortList, } from "../constants";
import OfferingsCheckboxListFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsCheckboxListFilters/OfferingsCheckboxListFilters";
import OfferingsRangeFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsRangeFilters/OfferingsRangeFilters";
import OfferingsRadioListFilters from "@frameworks/shared-library/components/Offerings/Generic/GenericFilterSort/OfferingsRadioListFilters/OfferingsRadioListFilters";
import FundSearchPanel from "@frameworks/shared-library/components/Generic/FundSeachPanel/FundSearchPanel";
import { nanoid } from "nanoid";
var INITIAL_VISIBLE_FILTERS_LENGTH = 4;
var TopFundsViewAllFunctionality = function (props) {
    var _a, _b, _c;
    var filterObject = function (configRequestPayload) {
        var _a, _b;
        if (configRequestPayload) {
            var subCategoriesList_1 = [];
            if (((_a = configRequestPayload === null || configRequestPayload === void 0 ? void 0 : configRequestPayload.subCatCode) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                (_b = configRequestPayload === null || configRequestPayload === void 0 ? void 0 : configRequestPayload.subCatCode) === null || _b === void 0 ? void 0 : _b.map(function (subCat) {
                    subCategoriesList_1.push(subCat);
                });
            }
            var reqObj = {
                Category: configRequestPayload.catCode,
                "Sub Category": subCategoriesList_1 || [],
                "Regular/Direct": configRequestPayload.schPlan
                    ? configRequestPayload.schPlan
                    : MFSchemesPlanTypes.REGULAR,
                Plan: configRequestPayload.sch_type
                    ? configRequestPayload.sch_type
                    : MFSchemsPlanes.GROWTH,
                "AUM Size in Cr": configRequestPayload.fundSize,
                "Fund House": configRequestPayload.amcFunds || [],
                benchmark: configRequestPayload.benchmark,
            };
            return reqObj;
        }
    };
    var uniqueIdForFilterPopup = nanoid();
    var section = useParams().section;
    var _d = __read(React.useState(false), 2), openSearch = _d[0], setOpenSearch = _d[1];
    var _e = __read(React.useState(false), 2), openSort = _e[0], setOpenSort = _e[1];
    var _f = __read(React.useState(false), 2), openFilter = _f[0], setOpenFilter = _f[1];
    var _g = __read(React.useState(filterObject(props.requestPayload)), 2), selectedFilters = _g[0], setSelectedFilters = _g[1];
    var _h = __read(React.useState([]), 2), filterLables = _h[0], setFilterLables = _h[1];
    var _j = __read(React.useState([]), 2), subCategoriesCode = _j[0], setSubCategoriesCode = _j[1];
    var _k = __read(React.useState([]), 2), subCategories = _k[0], setSubCatgories = _k[1];
    var _l = __read(React.useState([]), 2), fundHouseList = _l[0], setFundHouseList = _l[1];
    var _m = __read(useState(filterLables.length - INITIAL_VISIBLE_FILTERS_LENGTH), 2), remainingItemsLength = _m[0], setRemainingItemsLength = _m[1];
    var _o = __read(useState(false), 2), showFilterTagsPopover = _o[0], setShowFilterTagsPopover = _o[1];
    var _p = __read(React.useState(""), 2), searchValue = _p[0], setSearchValue = _p[1];
    var _q = __read(React.useState([]), 2), filterTabsList = _q[0], setFilterTabsList = _q[1];
    var _r = __read(React.useState((filterTabsList === null || filterTabsList === void 0 ? void 0 : filterTabsList.length) ? (_b = (_a = filterTabsList[0]) === null || _a === void 0 ? void 0 : _a.eventKey) === null || _b === void 0 ? void 0 : _b.toString() : ""), 2), filterTabActiveKey = _r[0], setFilterTabActiveKey = _r[1];
    var filterRef = React.useRef(null);
    var sortRef = React.useRef(null);
    var device = DeviceContext();
    var buttonRef = useRef(null);
    var getMutualFundsSchemes = function (requestPayload) {
        getMutualFundsData(requestPayload.selectedFilters, requestPayload.subCategoriesCode, requestPayload.pageNumber, true);
    };
    var getMutualFundsData = function (selectedFilters, subCategoriesCode, pageNumber, isRemoveFilter) {
        var _a;
        setSubCategoriesCode(subCategoriesCode);
        var reqObj = {
            // rating: selectedFilters["Morning Star Ratings"],
            fundSize: selectedFilters["AUM Size in Cr"],
            schPlan: selectedFilters["Regular/Direct"],
            schType: selectedFilters["Plan"],
            catCode: selectedFilters["Category"],
            subCatCode: ((_a = selectedFilters["Sub Category"]) === null || _a === void 0 ? void 0 : _a.length) > 0
                ? selectedFilters["Sub Category"]
                : subCategoriesCode,
            amcName: selectedFilters["Fund House"],
            benchmark: selectedFilters.benchmark,
            pageNo: pageNumber,
        };
        setSelectedFilters({
            Category: selectedFilters["Category"],
            "Sub Category": selectedFilters["Sub Category"],
            // "Morning Star Ratings": selectedFilters["Morning Star Ratings"],
            "Regular/Direct": selectedFilters["Regular/Direct"],
            Plan: selectedFilters["Plan"],
            "AUM Size in Cr": selectedFilters["AUM Size in Cr"],
            "Fund House": selectedFilters["Fund House"],
        });
        props.getMutualFundsSchems(reqObj);
        getFilterLabelsForApplied();
        //else di.mutualFunds.applyFilters(reqObj);
    };
    var MFCollection = useCustomSelector(function (state) {
        return state.markets.MutualFunds.exploreFunds.data.MFCollection;
    }, _.isEqual);
    var mutualFundsHousesList = useCustomSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsHousesReducer.mutualFundsHousesList;
    }, _.isEqual);
    var sortData = useCustomSelector(function (state) { return state.markets.MutualFunds.mutualFundsSchemes.sortData; }, _.isEqual);
    var searchState = useCustomSelector(function (state) {
        return state.markets.MutualFunds.mutualFundsSchemes.searchState.searchData;
    }, _.isEqual);
    var fundFilterDisbaled = useMemo(function () {
        if (section === "top-performing") {
            var cat = fundFilters.map(function (x) {
                if (x.filterName === "Category") {
                    return __assign(__assign({}, x), { disable: true });
                }
                return x;
            });
            return cat;
        }
        else {
            return fundFilters;
        }
    }, []);
    // React.useEffect(() => {
    //   di.mutualFunds.getMutualFundsHouses();
    // }, []);
    React.useEffect(function () {
        if (searchState) {
            setSearchValue(searchState);
        }
    }, [searchState]);
    React.useEffect(function () {
        getFilterLabelsForApplied();
    }, [props.mutualFundFilterSortValuesApplied]);
    var getFilterLabelsForApplied = function () {
        var filters = [];
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["subCatCode"].length > 0) {
            props.filtersDisplayData.category.list.filter(function (listItem) {
                var _a, _b;
                if (props.mutualFundFilterSortValuesApplied["subCatCode"].includes((_a = listItem.value) === null || _a === void 0 ? void 0 : _a.toString())) {
                    filters.push({
                        title: listItem.searchKey,
                        keyName: "Category",
                        subKeyName: listItem.value,
                        disable: handleCheckForDefaultAppliedFilters((_b = listItem === null || listItem === void 0 ? void 0 : listItem.value) === null || _b === void 0 ? void 0 : _b.toString(), "subCatCode", props === null || props === void 0 ? void 0 : props.currentActiveMutualFundCategory),
                    });
                }
            });
            //filters.push({ title: item.name, keyName: "Category" });.
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["amcName"].length > 0) {
            props.mutualFundFilterSortValuesApplied["amcName"].map(function (listItem) {
                filters.push({
                    title: listItem,
                    keyName: "Fund House",
                    subKeyName: listItem,
                });
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["riskValue"].length > 0) {
            props.filtersDisplayData.riskValue.list.filter(function (listItem) {
                var _a;
                if (props.mutualFundFilterSortValuesApplied["riskValue"].includes((_a = listItem.value) === null || _a === void 0 ? void 0 : _a.toString())) {
                    filters.push({
                        title: listItem.searchKey,
                        keyName: "Risk Value",
                        subKeyName: listItem.value,
                    });
                }
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["rating"].length > 0) {
            props.mutualFundFilterSortValuesApplied["rating"].map(function (listItem) {
                filters.push({
                    title: listItem,
                    keyName: "Rating",
                    subKeyName: listItem,
                });
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["fundSize"]) {
            filters.push({
                title: "AUM Size in Cr" +
                    props.mutualFundFilterSortValuesApplied["fundSize"].operator +
                    props.mutualFundFilterSortValuesApplied["fundSize"].value,
                keyName: "AUM Size in Cr",
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["year1"]) {
            filters.push({
                title: "1 yr CAGR" +
                    props.mutualFundFilterSortValuesApplied["year1"].operator +
                    props.mutualFundFilterSortValuesApplied["year1"].value,
                keyName: "1 yr CAGR",
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["year3"]) {
            filters.push({
                title: "3 yr CAGR" +
                    props.mutualFundFilterSortValuesApplied["year3"].operator +
                    props.mutualFundFilterSortValuesApplied["year3"].value,
                keyName: "3 yr CAGR",
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["year5"]) {
            filters.push({
                title: "5 yr CAGR" +
                    props.mutualFundFilterSortValuesApplied["year5"].operator +
                    props.mutualFundFilterSortValuesApplied["year5"].value,
                keyName: "5 yr CAGR",
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["expenseRatio"]) {
            filters.push({
                title: "ExpenseRatio " +
                    props.mutualFundFilterSortValuesApplied["expenseRatio"].operator +
                    props.mutualFundFilterSortValuesApplied["expenseRatio"].value,
                keyName: "ExpenseRatio",
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["schPlan"].length > 0) {
            filters.push({
                title: props.mutualFundFilterSortValuesApplied["schPlan"][0],
                keyName: "Plan",
            });
        }
        if (props.mutualFundFilterSortValuesApplied &&
            props.mutualFundFilterSortValuesApplied["schType"].length > 0) {
            filters.push({
                title: props.mutualFundFilterSortValuesApplied["schType"][0],
                keyName: "Regular/Direct",
            });
        }
        setFilterLables(filters);
    };
    function getFilterLabelsForAppliedOld() {
        var filters = [];
        if (selectedFilters && selectedFilters["Category"]) {
            var categoryName_1 = "";
            var disable_1 = false;
            fundFilterDisbaled &&
                fundFilterDisbaled.map(function (item) {
                    var _a;
                    if (item.filterName === "Category" &&
                        item.list &&
                        ((_a = item.list) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        item.list.map(function (listItem) {
                            if (listItem.key == selectedFilters["Category"]) {
                                categoryName_1 = listItem.title;
                            }
                        });
                        disable_1 = item.disable ? item.disable : true;
                    }
                });
            filters.push({ title: categoryName_1, keyName: "Category", disable: disable_1 });
        }
        if (selectedFilters && selectedFilters["Plan"]) {
            filters.push({ title: selectedFilters["Plan"], keyName: "Plan" });
        }
        if (selectedFilters && selectedFilters["Regular/Direct"]) {
            filters.push({
                title: selectedFilters["Regular/Direct"],
                keyName: "Regular/Direct",
            });
        }
        if (selectedFilters && selectedFilters["AUM Size in Cr"]) {
            filters.push({
                title: "AUM Size in Cr" + selectedFilters["AUM Size in Cr"],
                keyName: "AUM Size in Cr",
            });
        }
        if (selectedFilters && selectedFilters["Sub Category"]) {
            if (selectedFilters["Sub Category"] &&
                MFCollection &&
                MFCollection.length > 0) {
                selectedFilters["Sub Category"].map(function (item) {
                    MFCollection.map(function (catItem) {
                        if (catItem.ID == item &&
                            catItem.CategoryID == selectedFilters["Category"]) {
                            filters.push({
                                title: catItem.SubCategory,
                                keyName: "Sub Category",
                                subKeyName: catItem.ID,
                            });
                        }
                    });
                });
            }
            // filters = filters.concat(selectedFilters["Sub Category"]);
        }
        if (selectedFilters && selectedFilters["Fund House"]) {
            if (selectedFilters["Fund House"] &&
                mutualFundsHousesList &&
                mutualFundsHousesList.length > 0) {
                selectedFilters["Fund House"].map(function (item) {
                    filters.push({
                        title: item,
                        keyName: "Fund House",
                    });
                });
            }
        }
        setFilterLables(filters);
        //return filters;
    }
    React.useEffect(function () {
        function handleClickOutside(event) {
            if (sortRef.current && !sortRef.current.contains(event.target)) {
                setOpenSort(false);
            }
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setOpenFilter(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [sortRef, filterRef]);
    var applySearching = function (serchState) {
        setSearchValue(serchState);
        debounce(function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    di.mutualFunds.applySearching(serchState, props.mutualFundsSchemeList);
                    return [2 /*return*/];
                });
            });
        }, 300)();
    };
    var clearSearching = function () {
        setSearchValue("");
        applyFilteredValues("");
        debounce(function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    di.mutualFunds.clearSearching();
                    return [2 /*return*/];
                });
            });
        }, 300)();
    };
    React.useEffect(function () {
        if ((selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.Category) && MFCollection && MFCollection.length > 0) {
            var subCategoryList_1 = [];
            MFCollection.map(function (item) {
                if (item.CategoryID === Number(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.Category)) {
                    subCategoryList_1.push({
                        title: item.SubCategory,
                        key: item.ID,
                        selected: false,
                    });
                }
            });
            setSubCatgories(subCategoryList_1);
        }
        else {
            //di.mutualFunds.exploreFunds();
        }
    }, [MFCollection, selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.Category]);
    React.useEffect(function () {
        if (mutualFundsHousesList && mutualFundsHousesList.length > 0) {
            var fundHouseList_1 = [];
            mutualFundsHousesList.map(function (item) {
                fundHouseList_1.push({
                    title: item.fundsHouseName,
                    selected: false,
                    key: item.fundsHouseName,
                });
            });
            setFundHouseList(fundHouseList_1);
        }
        else {
            // di.mutualFunds.getMutualFundsHouses();
        }
    }, [mutualFundsHousesList]);
    React.useEffect(function () {
        return function () {
            di.mutualFunds.clearSorting();
            props === null || props === void 0 ? void 0 : props.handleCancelApplyingFiltersCallback();
        };
    }, []);
    var removeFilter = function (keyName, subKeyName) {
        var _a, _b, _c, _d;
        var tempData = selectedFilters;
        switch (keyName) {
            case "Category":
                var filteredIndex = -1;
                filteredIndex = props.mutualFundFilterSortValuesApplied["subCatCode"].findIndex(function (item, index) {
                    return item === subKeyName;
                });
                (_a = props.mutualFundFilterSortValuesApplied["subCatCode"]) === null || _a === void 0 ? void 0 : _a.splice(filteredIndex, 1);
                delete props.selectedFiltersData["subCatCode"][subKeyName];
                break;
            // // case "Morning Star Ratings":
            // //   tempData[keyName] = "";
            case "Plan":
                props.mutualFundFilterSortValuesApplied["schPlan"] = [];
                break;
            case "AUM Size in Cr":
                props.mutualFundFilterSortValuesApplied["fundSize"] = undefined;
                break;
            case "1 yr CAGR":
                props.mutualFundFilterSortValuesApplied["year1"] = undefined;
                break;
            case "3 yr CAGR":
                props.mutualFundFilterSortValuesApplied["year3"] = undefined;
                break;
            case "5 yr CAGR":
                props.mutualFundFilterSortValuesApplied["year5"] = undefined;
                break;
            case "ExpenseRatio":
                props.mutualFundFilterSortValuesApplied["expenseRatio"] = undefined;
                break;
            case "Regular/Direct":
                props.mutualFundFilterSortValuesApplied["schType"] = [];
                // case "Sub Category":
                break;
            case "Fund House":
                var filteredIndex1 = -1;
                filteredIndex1 = props.mutualFundFilterSortValuesApplied["amcName"].findIndex(function (item, index) {
                    return item === subKeyName;
                });
                (_b = props.mutualFundFilterSortValuesApplied["amcName"]) === null || _b === void 0 ? void 0 : _b.splice(filteredIndex1, 1);
                delete props.selectedFiltersData["amcName"][subKeyName];
                break;
            case "Risk Value":
                var filteredIndex2 = -1;
                filteredIndex2 = props.mutualFundFilterSortValuesApplied["riskValue"].findIndex(function (item, index) {
                    return item === subKeyName;
                });
                (_c = props.mutualFundFilterSortValuesApplied["riskValue"]) === null || _c === void 0 ? void 0 : _c.splice(filteredIndex2, 1);
                delete props.selectedFiltersData["riskValue"][subKeyName];
                break;
            case "Rating":
                var filteredIndex3 = -1;
                filteredIndex3 = props.mutualFundFilterSortValuesApplied["rating"].findIndex(function (item, index) {
                    return item === subKeyName;
                });
                (_d = props.mutualFundFilterSortValuesApplied["rating"]) === null || _d === void 0 ? void 0 : _d.splice(filteredIndex3, 1);
                delete props.selectedFiltersData["rating"][subKeyName];
        }
        props.handleUpdateSelectedFiltersState(props.selectedFiltersData);
        props.onFilterSelectionCallback(__assign({}, props.mutualFundFilterSortValuesApplied), true);
    };
    // TODO: Remove this function after client and salesJourney are updated and this component is used for both
    var removeFilterOld = function (keyName, subKeyName) {
        var tempData = selectedFilters;
        switch (keyName) {
            case "Category":
                tempData[keyName] = "";
            // case "Morning Star Ratings":
            //   tempData[keyName] = "";
            case "Plan":
                tempData[keyName] = "";
            case "AUM Size in Cr":
                tempData[keyName] = "";
            case "Regular/Direct":
                tempData[keyName] = "";
            case "Sub Category":
            case "Fund House":
                var subCategories_1 = tempData[keyName];
                if (subCategories_1 && subCategories_1.length > 0) {
                    var indexOF = subCategories_1.indexOf(subKeyName);
                    subCategories_1 === null || subCategories_1 === void 0 ? void 0 : subCategories_1.splice(indexOF, 1);
                    tempData[keyName] = subCategories_1;
                }
        }
        var filters = filterLables;
        if (keyName === "Sub Category" || keyName === "Fund House") {
            filters = filters.filter(function (filterObj) { return filterObj.subKeyName !== subKeyName; });
            setFilterLables(filters);
        }
        else {
            filters = filters.filter(function (filterObj) { return filterObj.keyName !== keyName; });
            setFilterLables(filters);
        }
        setSelectedFilters(tempData);
        getMutualFundsData(tempData, tempData["Sub Category"], 0, true);
        // getFilterLabelsForApplied();
    };
    var onSortRadioBtnChange = function (e, item) {
        props.mutualFundFilterSortValues["sortColumn"] =
            item.value == "NameDSC" ? "Name" : item.value;
        props.mutualFundFilterSortValues["sortOrder"] = item.type;
        props.onFilterSelectionCallback(__assign({}, props.mutualFundFilterSortValues));
    };
    var applyFilteredValues = function (searchText) {
        props.mutualFundFilterSortValues["searchText"] = searchText;
        props.onFilterSelectionCallback(__assign({}, props.mutualFundFilterSortValues), true);
    };
    var handleInputOnChange = function (e) {
        setSearchValue(e.target.value);
        if (e.target.value === "") {
            clearSearching();
        }
        if (e.target.value.length > 2) {
            debounce(function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        applyFilteredValues(e.target.value);
                        return [2 /*return*/];
                    });
                });
            }, 300)();
        }
    };
    var onCheckBoxChange = function (data) {
        var _a;
        (_a = Object.keys(data)) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
            props.mutualFundFilterSortValues[key] = Object.keys(data[key]).map(function (item) {
                return item;
            });
        });
        !!(props === null || props === void 0 ? void 0 : props.handleUpdateSelectedFiltersState) &&
            props.handleUpdateSelectedFiltersState(data);
        !!(props === null || props === void 0 ? void 0 : props.onFilterSelectionCallback) &&
            props.onFilterSelectionCallback(__assign({}, props.mutualFundFilterSortValues));
    };
    // const onCheckBoxChange = (
    //   e: React.ChangeEvent<HTMLInputElement>,
    //   param: keyof IMutualFundsFiltersRequestPayload
    // ) => {
    //   console.log("I am onchange");
    //   if (
    //     !!props.mutualFundFilterSortValues[param] &&
    //     Array.isArray(props.mutualFundFilterSortValues[param])
    //   ) {
    //     if (e.target.checked) {
    //       if (!!props.mutualFundFilterSortValues[param]) {
    //         (
    //           props.mutualFundFilterSortValues[param] as Array<string | number>
    //         ).push(e.target.value);
    //       } else {
    //         (props.mutualFundFilterSortValues[param] as Array<string>) = [
    //           e.target.value,
    //         ];
    //       }
    //     } else {
    //       let filteredIndex = -1;
    //       filteredIndex = (
    //         props.mutualFundFilterSortValues[param] as Array<string | number>
    //       )?.findIndex((item: string) => {
    //         return item === e.target.value;
    //       });
    //       (
    //         props.mutualFundFilterSortValues[param] as Array<string | number>
    //       )?.splice(filteredIndex, 1);
    //     }
    //   }
    //   props.onFilterSelectionCallback({ ...props.mutualFundFilterSortValues });
    // };
    var onDropDownChange = function (data, param) {
        var _a;
        var localObj = __assign({}, props.mutualFundFilterSortValues);
        var localFilterData = localObj[param];
        if (localFilterData) {
            localObj[param] = data.value;
        }
        else {
            localObj = __assign(__assign({}, localObj), (_a = {}, _a[param] = data.value, _a));
        }
        props.onFilterSelectionCallback(__assign({}, localObj));
    };
    var onInputFormChange = function (name, vale, param) {
        var _a;
        props.onFilterSelectionCallback(__assign(__assign({}, props.mutualFundFilterSortValues), (_a = {}, _a[param] = __assign(__assign({}, props.mutualFundFilterSortValues[param]), { value: vale }), _a)));
    };
    var onRadioBtnChange = function (e, isSchemeType) {
        if (isSchemeType) {
            props.mutualFundFilterSortValues.schPlan[0] = e.target.value;
        }
        else {
            props.mutualFundFilterSortValues.schType[0] = e.target.value;
        }
        props.onFilterSelectionCallback(__assign({}, props.mutualFundFilterSortValues));
    };
    var createFilterTabList = function () {
        var filterTabs = Object.keys(props.filtersDisplayData).map(function (key) {
            var obj = props.filtersDisplayData[key];
            if (!!obj) {
                return {
                    title: obj.title,
                    eventKey: obj.value,
                    tabContent: generateSpecificTabContent(obj.filterType, obj),
                };
            }
        });
        setFilterTabsList(filterTabs);
    };
    var generateSpecificTabContent = function (filterType, metaData) {
        switch (filterType) {
            case EMFFilterType.CHECKBOX:
                var keyName = metaData.value;
                return (React.createElement(OfferingsCheckboxListFilters, { key: keyName, displayDataList: metaData.list, 
                    // filterDataList={props.filterDisplayData[metaData.value].list}
                    enableSearch: metaData.enableSearchForFilter, selectedValuesList: props === null || props === void 0 ? void 0 : props.selectedFiltersData, onChangeCallback: onCheckBoxChange, parentKeyName: metaData.value, parentClassName: "rating-columns-filter", searchInputPlaceholder: metaData.placeholder, loader: props === null || props === void 0 ? void 0 : props.isShowFilterLoader }));
            case EMFFilterType.RANGE:
                return (React.createElement(OfferingsRangeFilters, { typeOfFilter: metaData.value, onDropDownChange: onDropDownChange, onInputFormChange: onInputFormChange, mutualFundFilterSortValues: props.mutualFundFilterSortValues, errorData: props === null || props === void 0 ? void 0 : props.filterFieldsErrors, inputLimit: metaData === null || metaData === void 0 ? void 0 : metaData.maxInputLength, inputPlaceholder: metaData === null || metaData === void 0 ? void 0 : metaData.placeholder, showInputSuffix: metaData === null || metaData === void 0 ? void 0 : metaData.showSuffixInInput }));
            case EMFFilterType.NESTED_RADIO:
                return generateNestedRadioFilterComp(metaData);
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    var generateNestedRadioFilterComp = function (metaData) {
        return metaData.nestedFilters.map(function (item) {
            var isSchemeType = item.title == "Scheme Type";
            return (React.createElement("div", { className: "bg-ghost-white3" },
                React.createElement("span", { className: "d-block txt_rhythm DMSansMedium_15_500 px-16 py-12" }, item.title),
                React.createElement(OfferingsRadioListFilters, { filterDataList: item.list, selectedRadioValue: isSchemeType
                        ? props.mutualFundFilterSortValues.schPlan.length > 0
                            ? props.mutualFundFilterSortValues.schPlan[0]
                            : null
                        : props.mutualFundFilterSortValues.schType.length > 0
                            ? props.mutualFundFilterSortValues.schType[0]
                            : null, onChangeCallback: function (e) {
                        onRadioBtnChange(e, isSchemeType);
                    } })));
        });
    };
    var handleFilterTabChange = function (selectedKey, e) {
        e.stopPropagation();
        setFilterTabActiveKey(selectedKey);
    };
    var handleFilterPopupTabChange = function (selectedKey, e) {
        e.stopPropagation();
    };
    React.useEffect(function () {
        if (!!props.filtersDisplayData) {
            createFilterTabList();
        }
    }, [
        props.filtersDisplayData,
        props.mutualFundFilterSortValues,
        props === null || props === void 0 ? void 0 : props.selectedFiltersData,
        props === null || props === void 0 ? void 0 : props.isShowFilterLoader,
        props === null || props === void 0 ? void 0 : props.filterFieldsErrors,
    ]);
    var handleSortTabDataChange = function (e, item) {
        props.mutualFundFilterSortValues["sortColumn"] = item.value;
        props.mutualFundFilterSortValues["sortOrder"] = item.type;
        props.onFilterSelectionCallback(__assign({}, props.mutualFundFilterSortValues), false);
    };
    var toggleShowFilterTagsPopover = function () {
        setShowFilterTagsPopover(!showFilterTagsPopover);
    };
    var handleApplyFilters = function () {
        var keys = (props === null || props === void 0 ? void 0 : props.filterFieldsErrors)
            ? Object.keys(props.filterFieldsErrors)
            : [];
        if (keys.length > 0 &&
            keys.findIndex(function (item) { return item === filterTabActiveKey; }) === -1)
            setFilterTabActiveKey(keys[0]);
        !!(props === null || props === void 0 ? void 0 : props.handleApplyFilterCallback) && props.handleApplyFilterCallback();
    };
    var handleCheckForDefaultAppliedFilters = function (filterValue, filterKey, currentActiveMutualFundCategory) {
        if (!currentActiveMutualFundCategory || !filterValue || !filterKey)
            return false;
        if (defaultMutualFundFilterConfig[currentActiveMutualFundCategory] &&
            defaultMutualFundFilterConfig[currentActiveMutualFundCategory][filterKey]) {
            if (Array.isArray(defaultMutualFundFilterConfig[currentActiveMutualFundCategory][filterKey]) &&
                defaultMutualFundFilterConfig[currentActiveMutualFundCategory][filterKey].includes(filterValue)) {
                return true;
            }
        }
        return false;
    };
    return (React.createElement("div", { className: (device === null || device === void 0 ? void 0 : device.isDesktop)
            ? "d-flex justify-content-between offerings-filter-section mb-20"
            : "d-flex flex-column-reverse" },
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(FundSearchPanel, { clearSearching: clearSearching, applySearchedFilters: applyFilteredValues, placeholder: "Search by fund name, category and more", parentClassName: "w-400", autoComplete: "off" })) : (React.createElement("div", { className: "d-flex bg_aqua_white align-items-center fund-search ".concat(openSearch && "open-search") },
            React.createElement("div", { className: "search-bar" },
                React.createElement("label", { htmlFor: "focus-input" }, openSearch ? (React.createElement("i", { className: "edel-icon-left-arrow txt-midnight-blue", onClick: function () { return setOpenSearch(false); } })) : (React.createElement("i", { className: "edel-icon-search txt-midnight-blue", onClick: function () { return setOpenSearch(true); } }))),
                React.createElement("input", { className: openSearch ? "bg_white" : "bg_aqua_white", id: "focus-input", type: "search", placeholder: (device === null || device === void 0 ? void 0 : device.isDesktop) ? "Search" : "", value: searchValue, onFocus: function () { return setOpenSearch(true); }, onChange: function (e) {
                        if (e.target.value !== "") {
                            setSearchValue(e.target.value);
                            applySearching(e.target.value);
                        }
                        else {
                            clearSearching();
                        }
                    }, onBlur: function () {
                        if (!searchValue) {
                            setSearchValue(searchValue);
                            setOpenSearch(false);
                        }
                    } }),
                openSearch && (React.createElement("label", { htmlFor: "focus-input" },
                    React.createElement("i", { className: " edel-icon-bold-close txt_secondary-gray", onClick: function () { return clearSearching(); } })))))),
        React.createElement("div", { className: "d-flex search-sort-filter ".concat(filterLables.length === 0 ? "hide-filter-bar" : "") },
            React.createElement("div", { className: (device === null || device === void 0 ? void 0 : device.isDesktop)
                    ? "top-funds filters-tag new-theme"
                    : "top-funds filters-tag d-flex new-theme" }, props.mutualFundFilterSortValuesApplied &&
                filterLables.length > 0 && (React.createElement(FilterValues, { filterLables: filterLables, removeFilter: removeFilter, toggleShowFilterTagsPopover: toggleShowFilterTagsPopover, setShowFilterTagsPopover: setShowFilterTagsPopover, showFilterTagsPopover: showFilterTagsPopover, setRemainingItemsLength: setRemainingItemsLength }))),
            section !== "sector" &&
                section !== "index" &&
                section !== "idea-for-investment" && (React.createElement("div", { className: "filter position-relative common-EdButtonIcon-icon d-flex w-100 justify-content-end" },
                !showFilterTagsPopover &&
                    remainingItemsLength > 0 &&
                    filterLables.length > 0 && (React.createElement("div", { className: "bg_white DMSanN_12_400 filters-tag-showmore-btn align-self-center hand_cursor text-nowrap" },
                    React.createElement("a", { ref: buttonRef, onClick: toggleShowFilterTagsPopover, className: "btn-text" }, "+".concat(remainingItemsLength, " more")))),
                React.createElement(GenericPopup, { placement: "bottom-end", parentClass: "filters-generic-popup-container", isHeadline: true, isShow: props === null || props === void 0 ? void 0 : props.isShowMainFilterSortPopup, setIsShow: function () {
                        return !!(props === null || props === void 0 ? void 0 : props.handleCancelApplyingFiltersCallback) &&
                            props.handleCancelApplyingFiltersCallback(props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValuesApplied);
                    }, removeTooltipArrow: true, containerDom: function () {
                        return document.getElementById(uniqueIdForFilterPopup);
                    }, buttonOnClick: function () {
                        !!(props === null || props === void 0 ? void 0 : props.setIsShowMainFilterSortPopup) &&
                            props.setIsShowMainFilterSortPopup(!(props === null || props === void 0 ? void 0 : props.isShowMainFilterSortPopup));
                        // setOpenFilter(!openFilter)
                    }, button: React.createElement("div", { className: "position-relative" },
                        React.createElement(EdButtonIcon, { id: uniqueIdForFilterPopup, className: "".concat((props === null || props === void 0 ? void 0 : props.isShowMainFilterSortPopup)
                                ? "filter-popup-active"
                                : "", " filter-popup-btn"), btnIcon: "edel-icon-filter-1", btnTyp: "link", slim: true, 
                            // onClick={() => {
                            //   console.log("dshkjfhdskjfhdsjkf jgfhsdgdshfds");
                            //   !!props?.setIsShowMainFilterSortPopup &&
                            //     props.setIsShowMainFilterSortPopup(
                            //       !props?.isShowMainFilterSortPopup
                            //     );
                            //   // setOpenFilter(!openFilter)
                            // }}
                            // className={
                            //   openFilter ? "bg-midnight-blue" : "bg_aqua_white"
                            // }
                            paths: 3 }),
                        (filterLables === null || filterLables === void 0 ? void 0 : filterLables.length) > 0 && (React.createElement("span", { className: "filter-selected d-flex" }))), children: React.createElement("div", { className: "offerings-filters-sort-tabs-primary-container", onClick: function (e) { return e.stopPropagation(); } },
                        React.createElement("div", null,
                            React.createElement(GenericTabs, { defaultActiveKey: "filter", callBackFunction: handleFilterPopupTabChange, externalClassName: "offerings-sort-filter-tabs w-100", tabsArray: [
                                    {
                                        title: "Filter",
                                        eventKey: "filter",
                                        tabContent: (React.createElement(OfferingsFilterTab
                                        // filterDisplayData={props.filtersDisplayData}
                                        // mutualFundFilterSortValues={
                                        //   props.mutualFundFilterSortValues
                                        // }
                                        // onFilterSelectionCallback={
                                        //   props.onFilterSelectionCallback
                                        // }
                                        , { 
                                            // filterDisplayData={props.filtersDisplayData}
                                            // mutualFundFilterSortValues={
                                            //   props.mutualFundFilterSortValues
                                            // }
                                            // onFilterSelectionCallback={
                                            //   props.onFilterSelectionCallback
                                            // }
                                            filterTabs: filterTabsList, filterTabActiveKey: filterTabActiveKey, handleFilterTabChange: handleFilterTabChange })),
                                    },
                                    {
                                        title: "Sort",
                                        eventKey: "sort",
                                        tabContent: (React.createElement(OfferingsSortTab, { filterDataList: FilterSortList, 
                                            // onChangeCallback={onRadioBtnChange}
                                            onChangeCallback: handleSortTabDataChange, selectedRadioValue: ((_c = props.mutualFundFilterSortValues) === null || _c === void 0 ? void 0 : _c.sortColumn)
                                                ? props.mutualFundFilterSortValues
                                                    .sortColumn
                                                : null })),
                                    },
                                ] }),
                            React.createElement("div", { className: "filter-sort-clear-btn-wrapper" },
                                React.createElement(EdButton, { btnTyp: "text-only", className: "txt-han-blue DMSanN_14_400", value: "Clear All", onClick: function () {
                                        return (props === null || props === void 0 ? void 0 : props.handleClearAllFiltersCallback) &&
                                            props.handleClearAllFiltersCallback();
                                    } }))),
                        React.createElement("div", { className: "d-flex align-items-center gap-2 justify-content-between offerings-filters-action-buttons-footer bg_white" },
                            React.createElement(EdButton, { btnTyp: "text-only", value: "Cancel", onClick: function () {
                                    return !!(props === null || props === void 0 ? void 0 : props.handleCancelApplyingFiltersCallback) &&
                                        props.handleCancelApplyingFiltersCallback(props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValuesApplied);
                                }, className: "offerings-custom-button DMSan_14_500 txt-han-blue w-100" }),
                            React.createElement(EdButton, { btnTyp: "tomato", value: "Apply", onClick: handleApplyFilters, className: "offerings-custom-button DMSan_14_500" }))) }))))));
};
export default TopFundsViewAllFunctionality;
